import type { WorkspaceTemplateRow } from '../../templates/partitionWorkspaceTemplates';
import type { EditFlowSelection } from './editFlow';

/** Strip the `wa-` / `sms-` / `em-` prefix from a Modelli workspace row id. */
export const parseWorkspaceRowProviderId = (rowId: string): string => {
  const match = /^(?:wa|sms|em)-(.+)$/.exec(rowId);
  return match?.[1] ?? rowId;
};

/** Build Edit/Delete Template selection from a workspace list row (always includes provider id + name). */
export const workspaceRowToEditSelection = (row: WorkspaceTemplateRow): EditFlowSelection => {
  const id = parseWorkspaceRowProviderId(row.id);
  if (row.channel === 'whatsapp') {
    const language = typeof row.formData['template_language'] === 'string' ? row.formData['template_language'] : '';
    return {
      channel: 'whatsapp',
      template: { id, name: row.name, language },
    };
  }
  return {
    channel: row.channel,
    template: { id, name: row.name },
  };
};
